export type VerifyType =
  | "passport"
  | "transaction"
  | "event"
  | "sink"
  | "user"
  | null;

export function detectRoute(input: string): string | null {
  const v = input.trim();
  if (!v) return null;
  if (/^FSEVT/i.test(v)) return `/event/${v}`;
  if (/^FSTX/i.test(v)) return `/transaction/${v}`;
  if (/^FS(\d{3}|[1-9]K[0-9])/i.test(v)) return `/passport/${v}`;
  if (/^[A-Z]{2}-[A-Za-z0-9]{4}$/i.test(v)) return `/sink/${v}`;
  if (/^[A-Za-z0-9]{8}$/.test(v)) return `/user/${v}`;
  return null;
}

export function detectType(input: string): VerifyType {
  const v = input.trim();
  if (!v) return null;
  if (/^FSEVT/i.test(v)) return "event";
  if (/^FSTX/i.test(v)) return "transaction";
  if (/^FS(\d{3}|[1-9]K[0-9])/i.test(v)) return "passport";
  if (/^[A-Z]{2}-[A-Za-z0-9]{4}$/i.test(v)) return "sink";
  if (/^[A-Za-z0-9]{8}$/.test(v)) return "user";
  return null;
}
